import { useAuth } from '@/auth/context/AuthContext'

const GRUPO_ADMIN = ['admin', 'BdUnificada-admin']

/** Indica si el usuario puede gestionar (editar/borrar/config/fuentes/cargas/cola). */
export function useCanAdmin(): boolean {
  const { user } = useAuth()
  if (!user) return false
  return user.is_superuser || GRUPO_ADMIN.some((g) => user.groups.includes(g))
}
